module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1012-3a0b29e0dfa00cc0bb90b4c1aebf803a.png";